<div class="content content-fixed">
  <div class="container">
    <div class="page-title-box d-sm-flex align-items-center justify-content-between mb-3">
      <h4 class="mb-0">{{'Dashboard' | translate }}</h4>
    </div>
    <div class="card mt-3" *ngIf="!isLoading">
      <div class="card-header p-2">
        <h5 class="mt-2">{{'Data Source Summary' | translate}}</h5>
      </div>
      <div>
        <table class="table standard-table standard-table-bordered table-striped">
          <thead class="text-center">
            <tr>
              <th class="align-middle W-200" rowspan="2" colspan="1" scope="col">{{'Source of Data' | translate}}</th>
              <th class="align-middle" rowspan="2" colspan="1" scope="col">{{'No of Records' | translate}}</th>
              <th class="align-middle" rowspan="2" colspan="1" scope="col">{{'Merged Records' | translate}}</th>
              <th class="align-middle" rowspan="2" colspan="1" scope="col">{{'Merged Percentage' | translate}}</th>
              <th class="align-middle" rowspan="2" colspan="1" scope="col">{{'Disclosed Relationships' | translate}}</th>
              <th class="align-middle" rowspan="1" colspan="2">{{'Discovered Relationships' | translate}}</th>
              <th class="align-middle" rowspan="2" colspan="1" scope="col">{{'Discovered Percentage' | translate}}</th>
            </tr>
            <tr>
              <th scope="col">{{'Possible Matches' | translate}}</th>
              <th scope="col">{{'Possible Relationships' | translate}}</th>
            </tr>
          </thead>
          <tbody class="text-center" *ngIf="allDataSourcesSummaryStats.length">
            <tr *ngFor="let data of allDataSourcesSummaryStats">
              <td class="font-weight-bold text-left">{{data.dataSourceCode}}</td>
              <td>{{data.recordCount | number }}</td>
              <td>{{data.mergedRecordCount | number }}</td>
              <td>{{data.mergedRecordPercent | number }}%</td>
              <td>{{data.disclosedRecordCount | number }}</td>
              <td>{{data.possibleMatchCount | number }}</td>
              <td>{{data.possibleRelationshipCount | number }}</td>
              <td>{{data.discoveredPercent | number }}%</td>
            </tr>
          </tbody>
          <tbody *ngIf="!allDataSourcesSummaryStats.length">
            <tr><td class="no-data-available" colspan="8">{{'No Data Found' | translate}}</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    
    
    <div class="card mt-3" *ngIf="!isLoading">
      <div class="card-header p-2 d-flex">
        <h5 class="mt-2 mrgn-51">{{'Cross Source Summary' | translate}}</h5>
        <div class="col-4 p-0 ml-2 mb-1 form-group">
          <select class="form-control" (ngModelChange)="onDataSourceSelect($event)" [ngModel]="selectedDatasourceId">
            <option value="Select" disabled>Select</option>
            <option *ngFor="let option of dataSources" [value]="option.id">{{option.name}}</option>
          </select>
        </div>
      </div>
      <table class="table standard-table standard-table-bordered table-striped">
        <thead class="text-center">
          <tr>
            <th class="align-middle" scope="col">{{'Primary' | translate}}</th>
            <th class="align-middle" scope="col">{{'Matched to' | translate}}</th>
            <th class="align-middle" scope="col">{{'Match' | translate}}</th>
            <th class="align-middle" scope="col">{{'Disclosed' | translate}}</th>
            <th class="align-middle" scope="col">{{'Possible Match' | translate}}</th>
            <th class="align-middle" scope="col">{{'Ambiguous' | translate}}</th>
            <th class="align-middle">{{'Possibly Related' | translate}}</th>
            <th class="align-middle">{{'Actions' | translate}}</th>
          </tr>
        </thead>
        <tbody class="text-center" *ngIf="crossMatchSummaryStats.length">
          <tr *ngFor="let data of crossMatchSummaryStats">
            <td>{{data.dataSourceCode}}</td>
            <td>{{data.relatedDataSourceCode}}</td>
            <td class="text-center">{{data.matchCount | number }}</td>
            <td class="text-center">{{data.disclosedRecordCount | number }}</td>
            <td class="text-center">{{data.possibleMatchesCount | number }}</td>
            <td class="text-center">{{data.ambiguousCount | number }}</td>
            <td class="text-center">{{data.possibleRelationshipsCount | number }}</td>
            <td class="text-center">
              <a [routerLink]="['/home/cross-match', { firstDataSource: data.dataSourceId, secondDataSource: data.relatedDataSourceId }]">
                Show Entities
              </a>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!crossMatchSummaryStats.length">
          <tr><td class="no-data-available" colspan="7">{{'No Data Found' | translate}}</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-spinner *ngIf="isLoading || isCrossMatchLoading" class="spinner-position"></app-spinner>
